import { render, staticRenderFns } from "./TechInfo.vue?vue&type=template&id=cd05dea2&"
import script from "./TechInfo.vue?vue&type=script&lang=js&"
export * from "./TechInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports